export default {
  actionIcon    : 'StarIcon',
  highlightColor: 'warning',
  data          : [
    {
      index: 0,
      label: 'Mis Estudiantes',
      url: '/students/list',
      labelIcon: 'CheckSquareIcon',
      highlightAction: true,
      active:false
    },
    {
      index: 1,
      label: 'Direcciones',
      url: '/my-addresses',
      labelIcon: 'CheckSquareIcon',
      highlightAction: true,
      active:false
    },
    {
      index: 0,
      label: 'Datos de facturación',
      url: '/data-billing',
      labelIcon: 'CheckSquareIcon',
      highlightAction: true,
      active:false
    },
    {
      index: 0,
      label: 'Órdenes',
      url: '/list/order-buy',
      labelIcon: 'CheckSquareIcon',
      highlightAction: true,
      active:false
    },
    {
      index: 0,
      label: 'Lista Completa',
      url: '/list/complete',
      labelIcon: 'CheckSquareIcon',
      highlightAction: true,
      active:false
    },
  ]
}
